<template>
	<div>
		<div
			class="vh-100 w-100 d-flex justify-content-center align-items-center flex-column mt-5 py-lg-5"
		>
			<div class="container pb-5">
				<Card shadow no-body class="py-sm px-sm">
					<b-row class="mt-sm justify-content-center">
						<b-col class="text-center">
							<h4>
								Thank you! This document has been signed. To view your signed document,
								please navigate to the button below.
							</h4>
						</b-col>
					</b-row>
					<b-row class="justify-content-center">
						<b-col class="text-center">
							<i class="text-muted" style="font-size: 12px">
								Please note: A saved copy has been delievered to our admins.
							</i>
						</b-col>
					</b-row>
					<b-row v-if="documentLink" class="my-2 justify-content-center">
						<b-col class="text-center">
							<BaseButton
								tag="a"
								:href="documentLink"
								target="_blank"
								style="color: white;"
								>View Your Signed Document</BaseButton
							>
						</b-col>
					</b-row>
				</Card>
			</div>
		</div>
	</div>
</template>

<script>
import Card from '../../components/Card.vue';
import { GeneralPaths } from '../../routes/routesNames';
import BaseButton from '../../components/BaseButton.vue';

export default {
	props: {
		documentLink: {
			type: String,
			default: null,
		},
		orgData: {
			type: Object,
			default: null,
		},
		organizationData: {
			type: Object,
			default: null,
		},
		fileData: {
			type: Object,
			default: null,
		},
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	data() {
		return {};
	},
	components: { Card, BaseButton },
	mounted() {
		if (this.documentLink == null) {
			this.$router.replace({
				name: GeneralPaths.notFound.name,
			});
		}
	},
};
</script>
